function getRandomBoundary(min: number, max: number, type: 'px' | '%' | 'rem' | 'em' = 'px') {
	const value = Math.random() * (max - min) + min;

	return `${value}${type}`;
}

function generateListItems(count) {
	return Array.from({ length: count }, (_, i) => i);
}

export { getRandomBoundary, generateListItems };
